export enum PagesEnum {
  Mailbox = 'postfach',
  ReadMail = 'readmail',
  SendMail = 'sendmail'
}
